import { useParams } from 'react-router-dom';

export const useRequiredParams = <T extends Record<string, string | undefined>>(): Required<T> => {
    const params = useParams<T>();

    return params as Required<T>;
};
